import { RESET_TEAMS_BY_TOURNAMENT, SELECT_TEAM_FROM_TOURNAMENT, SET_TEAMS_BY_TOURNAMENT, SHOW_MODAL_SELECTOR_TEAMS } from "../constants/teams"

export const setTeamsByTournament = teams => dispatch => {
    dispatch({
        type: SET_TEAMS_BY_TOURNAMENT,
        payload: teams
    })
}

export const resetTeamsByTournament = ()=> dispatch =>{
    dispatch({
        type: RESET_TEAMS_BY_TOURNAMENT,
    })
}

export const showSelectorModalTeams = showModal => dispatch =>{
    dispatch({
        type:SHOW_MODAL_SELECTOR_TEAMS,
        payload: showModal
    })
}

export const selectTeamFromTournament = team => dispatch =>{
    dispatch({
        type: SELECT_TEAM_FROM_TOURNAMENT,
        payload: team
    })
}

